export default class ServicoCreateServicoController {
  constructor($q, $state, $scope, AuthenticationService, UIService, ServicoService, Servico, ServicoParticipante, ServicoInstituicao, ServicoAreaInterdisciplinar, EntidadeFinanciadora, Investigador, Instituicao, AreaInterdisciplinar, Setor, Impacto, ImpactoOds, Ods, Pais) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.ServicoService = ServicoService;
    this.loaded = false;

    this.Servico = Servico;
    this.ServicoParticipante = ServicoParticipante;
    this.ServicoInstituicao = ServicoInstituicao;
    this.ServicoAreaInterdisciplinar = ServicoAreaInterdisciplinar;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Investigador = Investigador;
    this.Instituicao = Instituicao;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Setor = Setor;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.entidadesFinanciadoras = null;
    this.investigadores = null;
    this.setores = null;


    this.emptyData = {
      form: 1,
      details: {},
      impacto: {ods: []},

      instituicoes: [],
      participantes: [],
      areas: [],
      auxEntidadeFinanciadora: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxSetor: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInvestigador: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxCoordenacao: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxAdoption: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxImpactoAmbiental: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoEconomico: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoSocial: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoPolicyInfluence: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    // Configuration for date picker data
    this.dateOptions = {
      dataInicio: {format: 'DD/MM/YYYY'},
      dataFim: {format: 'DD/MM/YYYY'}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_ServicoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.EntidadeFinanciadora.find({}).$promise.then((entidadesFinanciadoras) => {
      this.entidadesFinanciadoras = entidadesFinanciadoras;
      this.Investigador.find({}).$promise.then((investigadores) => {
        investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
        this.investigadores = investigadores;
        this.Setor.find({}).$promise.then((setores) => {
          this.setores = setores;
          this.loadDataFromStorage();
          this.loaded = true;
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro ao carregar setores. Verifique a sua ligação");
          this.state.go('app.servico.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar investigadores. Verifique a sua ligação");
        this.state.go('app.servico.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar entidades. Verifique a sua ligação");
      this.state.go('app.servico.list');
    });
  };


  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_ServicoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_ServicoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.impacto) this.data.impacto = storageData.impacto; else this.data.impacto = angular.copy(this.emptyData.impacto);

      if (storageData.instituicoes) this.data.instituicoes = storageData.instituicoes; else this.data.instituicoes = angular.copy(this.emptyData.instituicoes);
      if (storageData.participantes) this.data.participantes = storageData.participantes; else this.data.participantes = angular.copy(this.emptyData.participantes);
      if (storageData.areas) this.data.areas = storageData.areas; else this.data.areas = angular.copy(this.emptyData.areas);

      if (storageData.auxEntidadeFinanciadora) this.data.auxEntidadeFinanciadora = storageData.auxEntidadeFinanciadora; else this.data.auxEntidadeFinanciadora = angular.copy(this.emptyData.auxEntidadeFinanciadora);
      if (storageData.auxSetor) this.data.auxSetor = storageData.auxSetor; else this.data.auxSetor = angular.copy(this.emptyData.auxSetor);
      if (storageData.auxInvestigador) this.data.auxInvestigador = storageData.auxInvestigador; else this.data.auxInvestigador = angular.copy(this.emptyData.auxInvestigador);

      if (storageData.auxCoordenacao) this.data.auxCoordenacao = storageData.auxCoordenacao; else this.data.auxCoordenacao = angular.copy(this.emptyData.auxCoordenacao);
      if (storageData.auxAdoption) this.data.auxAdoption = storageData.auxAdoption; else this.data.auxAdoption = angular.copy(this.emptyData.auxAdoption);

      if (storageData.auxImpactoAmbiental) this.data.auxImpactoAmbiental = storageData.auxImpactoAmbiental; else this.data.auxImpactoAmbiental = angular.copy(this.emptyData.auxImpactoAmbiental);
      if (storageData.auxImpactoEconomico) this.data.auxImpactoEconomico = storageData.auxImpactoEconomico; else this.data.auxImpactoEconomico = angular.copy(this.emptyData.auxImpactoEconomico);
      if (storageData.auxImpactoSocial) this.data.auxImpactoSocial = storageData.auxImpactoSocial; else this.data.auxImpactoSocial = angular.copy(this.emptyData.auxImpactoSocial);
      if (storageData.auxImpactoPolicyInfluence) this.data.auxImpactoPolicyInfluence = storageData.auxImpactoPolicyInfluence; else this.data.auxImpactoPolicyInfluence = angular.copy(this.emptyData.auxImpactoPolicyInfluence);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.servico.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.servico.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.servico.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Servico and related data
      this.data.details.id = 0;
      this.data.details.entidadeFinanciadoraId = this.data.auxEntidadeFinanciadora.selected.id;
      this.data.details.setorId = this.data.auxSetor.selected.id;
      this.data.details.investigadorId = this.data.auxInvestigador.selected.id;

      this.data.details.coordenacao = this.data.auxCoordenacao.selected.value;
      this.data.details.commercialAdoptions = this.data.auxAdoption.selected.value;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Servico.create(this.data.details).$promise.then((servico) => {

        // Create all Participantes
        let deferParticipantes = this.$q.defer();
        this.ServicoService.createMultipleData(this.ServicoParticipante, this.data.participantes, servico.id, 'servicoId').then((x) => {
          deferParticipantes.resolve({ok: true});
        }).catch(err => {
          deferParticipantes.resolve({ok: false, output: 'Outros Participantes'});
        });

        // Create all Instituições
        let deferInstituicoes = this.$q.defer();
        this.ServicoService.createMultipleData(this.ServicoInstituicao, this.data.instituicoes, servico.id, 'servicoId').then((x) => {
          deferInstituicoes.resolve({ok: true});
        }).catch(err => {
          deferInstituicoes.resolve({ok: false, output: 'Outras Entidades envolvidas'});
        });

        // Create all Áreas
        let deferAreas = this.$q.defer();
        this.ServicoService.createMultipleData(this.ServicoAreaInterdisciplinar, this.data.areas, servico.id, 'servicoId').then((x) => {
          deferAreas.resolve({ok: true});
        }).catch(err => {
          deferAreas.resolve({ok: false, output: 'Áreas Interdisciplinares'});
        });

        // Save Impacto
        let deferImpacto = this.$q.defer();
        this.saveImpacto(this.data.impacto, servico, this.Servico).then(x => {
          deferImpacto.resolve({ok: true});
        }).catch(err => {
          deferImpacto.resolve(err); // Resolve data is solved inside since it's multi-answer
        });

        let promises = [deferParticipantes.promise, deferInstituicoes.promise, deferAreas.promise, deferImpacto.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Serviço criado com sucesso");

          localStorage.removeItem('ISR_SGI_ServicoNewForm');

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Serviço criado, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.servico.details', {id: servico.id});
            });
          } else {
            this.state.go('app.servico.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_ServicoNewForm');
          alert = this.UI.showAlert("Serviço criado, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.servico.details', {id: servico.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar serviço. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if servico data is well defined
    // Acrónimo
    if (v && (!this.data.details.acronimo || this.data.details.acronimo.length === 0)) {
      this.UI.addToast("Acrónimo não preenchido");
      v = false;
      validDefer.reject();
    }

    // Título
    if (v && (!this.data.details.titulo || this.data.details.titulo.length === 0)) {
      this.UI.addToast("Título não preenchido");
      v = false;
      validDefer.reject();
    }

    // Data de Início
    if (v && (!moment(this.data.details.dataInicio).isValid())) {
      this.UI.addToast("Data de Início inválida");
      v = false;
      validDefer.reject();
    }

    // Data de Fim
    if (v && (!moment(this.data.details.dataFim).isValid())) {
      this.UI.addToast("Data de Fim inválida");
      v = false;
      validDefer.reject();
    }

    // Financiamento
    if (v && (isNaN(this.data.details.financiamento))) {
      this.UI.addToast("Financiamento não preenchido");
      v = false;
      validDefer.reject();
    }


    // Entidade Financiadora
    if (v && (!this.data.auxEntidadeFinanciadora || !this.data.auxEntidadeFinanciadora.selected)) {
      this.UI.addToast("Entidade Financiadora inválida");
      v = false;
      validDefer.reject();
    }

    // Setor
    if (v && (!this.data.auxSetor || !this.data.auxSetor.selected)) {
      this.UI.addToast("Setor inválido");
      v = false;
      validDefer.reject();
    }

    // Responsável
    if (v && (!this.data.auxInvestigador || !this.data.auxInvestigador.selected)) {
      this.UI.addToast("Responsável ISR inválido");
      v = false;
      validDefer.reject();
    }

    // Coordenação ISR
    if (v && (!this.data.auxCoordenacao || !this.data.auxCoordenacao.selected)) {
      this.UI.addToast("Coordenação ISR - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Commercial Adoptions
    if (v && (!this.data.auxAdoption || !this.data.auxAdoption.selected)) {
      this.UI.addToast("Commercial Adoptions - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data
    if (v && (this.data.areas.length === 0)) {
      this.UI.addToast("Áreas Interdisciplinares não preenchidas");
      v = false;
      validDefer.reject();
    }

    if (v && (this.data.areas.length > 3)) {
      this.UI.addToast("Só podem ser adicionadas 3 áreas interdisciplinares");
      v = false;
      validDefer.reject();
    }

    // Check if data is unique for multiple data
    // Participantes
    let participantes = this.data.participantes.map(x => x.investigadorId);
    let participantesRepetidos = participantes.filter((x, i) => participantes.indexOf(x) !== i);
    if (v && participantesRepetidos.length > 0) {
      this.UI.addToast("Outros participantes repetidos");
      v = false;
      validDefer.reject();
    }
    // Instituições
    let instituicoes = this.data.instituicoes.map(x => x.instituicaoId);
    let instituicoesRepetidas = instituicoes.filter((x, i) => instituicoes.indexOf(x) !== i);
    if (v && instituicoesRepetidas.length > 0) {
      this.UI.addToast("Outras entidades repetidas");
      v = false;
      validDefer.reject();
    }
    // Áreas Interdisciplinares
    let areas = this.data.areas.map(x => x.areaId);
    let areasRepetidas = areas.filter((x, i) => areas.indexOf(x) !== i);
    if (v && areasRepetidas.length > 0) {
      this.UI.addToast("Áreas Interdisciplinares repetidas");
      v = false;
      validDefer.reject();
    }


    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // Add multi async data to verify
      this.data.participantes.forEach(x => {
        idData.push({
          field: 'id',
          value: x.investigadorId,
          model: this.Investigador,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Investigador inexistente"
        });
      });
      this.data.instituicoes.forEach(x => {
        idData.push({
          field: 'id',
          value: x.instituicaoId,
          model: this.Instituicao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Instituição inexistente"
        });
      });
      this.data.areas.forEach(x => {
        idData.push({
          field: 'id',
          value: x.areaId,
          model: this.AreaInterdisciplinar,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Área Interdisciplinar inexistente"
        });
      });


      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.ServicoService.validateMultiData(idData).then(x => {

        // Verify impactos
        this.verifyImpactos(this.data.impacto).then(y => {
          wait.close();
          validDefer.resolve();
        }).catch(() => {
          wait.close();
          validDefer.reject();
        });

      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs
  // Adicionar um novo investigador para servico
  addParticipante = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.participante.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.participante = {};
          $scope.label = "Adicionar Outro Participante";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.participante) {
          let item = angular.copy(ok.participante);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);

          this.data.participantes.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para serviço. Verifique a sua ligação");
    });
  };

  // Edita informação de participante para servico
  editParticipante = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.participante.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.participante = angular.copy(x);
          $scope.label = "Editar Participante";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: $scope.participante.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.participante) {
          x.investigadorId = ok.auxInvestigador.selected.id;
          x.investigador = angular.copy(ok.auxInvestigador.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para serviço. Verifique a sua ligação");
    });
  };

  // Remove Participante com índice index
  removeParticipante = (index) => {
    if (index < this.data.participantes.length) {
      this.data.participantes.splice(index, 1);
    }
  };


  // Adicionar uma nova área interdisciplinar para orientação
  addArea = () => {
    // Only allow a max of 3 areas
    if (this.data.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = {};
          $scope.label = "Adicionar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          let item = angular.copy(ok.area);

          item.areaId = ok.auxArea.selected.id;
          item.area = ok.auxArea.selected;

          this.data.areas.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para prestação de serviço. Verifique a sua ligação");
    });

  };

  // Edita informação de área interdisciplinar para orientação
  editArea = (x) => {
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = angular.copy(x);
          $scope.label = "Editar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: $scope.area.area,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          x.areaId = ok.auxArea.selected.id;
          x.area = angular.copy(ok.auxArea.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para prestação de serviço. Verifique a sua ligação");
    });
  };

  // Remove área interdisciplinar com índice index
  removeArea = (index) => {
    if (index < this.data.areas.length) {
      this.data.areas.splice(index, 1);
    }
  };


  // Instituições
  // Adicionar um nova instituicao para produto
  addInstituicao = () => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.instituicao = {};
          $scope.label = "Adicionar Instituição envolvida";
          $scope.instituicoes = instituicoes;

          $scope.auxInstituicao = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          let item = angular.copy(ok.instituicao);
          item.instituicaoId = ok.auxInstituicao.selected.id;
          item.instituicao = angular.copy(ok.auxInstituicao.selected);

          this.data.instituicoes.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
    });
  };

  // Edita informação de instituicao para produto
  editInstituicao = (x) => {
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.instituicao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.instituicao = angular.copy(x);
          $scope.label = "Editar Instituição envolvida";
          $scope.instituicoes = instituicoes;

          $scope.auxInstituicao = {
            selected: $scope.instituicao.instituicao,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.instituicaoId = ok.auxInstituicao.selected.id;
          x.instituicao = angular.copy(ok.auxInstituicao.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeInstituicao = (index) => {
    if (index < this.data.instituicoes.length) {
      this.data.instituicoes.splice(index, 1);
    }
  };


  // Impactos
  // Get data to be used in impacto edit modal
  getImpactoData = (tipo) => {
    let wait;
    let defer = this.$q.defer();
    switch(tipo) {
      case 'Ambiental':
        defer.resolve(null);
        break;
      case 'Económico':
        wait = this.UI.showWaiting();
        this.Pais.find({
          filter: {
            order: 'ordem ASC'
          }
        }).$promise.then((paises) => {
          wait.close();
          defer.resolve(paises);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'ODS':
        wait = this.UI.showWaiting();
        this.Ods.find({}).$promise.then((ods) => {
          wait.close();
          defer.resolve(ods);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'Social':
        defer.resolve(null);
        break;
    }
    return defer.promise;
  };

  // Edit/add impacto for tipo
  editImpacto = (tipo) => {
    this.getImpactoData(tipo).then(externalData => {
      let options = {
        size: 'lg',
        template: require('./impacto.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipo = tipo;
          $scope.label = "Editar Impacto " + tipo;
          $scope.impacto = angular.copy(this.data.impacto);
          switch(tipo) {
            case 'Ambiental':
              $scope.simnao = this.simnao;
              $scope.auxImpactoAmbiental = angular.copy(this.data.auxImpactoAmbiental);
              break; // Nothing to do
            case 'Económico':
              $scope.simnao = this.simnao;
              $scope.auxImpactoEconomico = angular.copy(this.data.auxImpactoEconomico);
              break;
            case 'ODS':
              $scope.externalData = externalData;
              // ODS is always "add", so it always starts as empty
              $scope.auxOds = {
                selected: undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              break;
            case 'Social':
              $scope.simnao = this.simnao;
              $scope.auxImpactoSocial = angular.copy(this.data.auxImpactoSocial);
              break;
          }

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        switch(tipo) {
          case 'Ambiental':
            if(ok.auxImpactoAmbiental && ok.auxImpactoAmbiental.selected.value) { // Has "Yes" selected
              this.data.auxImpactoAmbiental = angular.copy(ok.auxImpactoAmbiental);
              this.data.impacto.ambiental = ok.impacto.ambiental;
              this.UI.addToast("Impacto ambiental atualizado");
            } else { // No ambiental data is defined, delete it
              if (this.data.impacto.ambiental) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoAmbiental.selected = undefined;
                delete this.data.impacto.ambiental;
                this.UI.addToast("Impacto ambiental eliminado");
              }
            }
            break;
          case 'Económico':
            if(ok.auxImpactoEconomico && ok.auxImpactoEconomico.selected.value) { // Has "Yes" selected
              this.data.auxImpactoEconomico = angular.copy(ok.auxImpactoEconomico);
              this.data.impacto.economico = ok.impacto.economico;
              this.UI.addToast("Impacto económico atualizado");
            } else { // No economico data is defined, delete it
              if (this.data.impacto.economico) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoEconomico.selected = undefined;
                delete this.data.impacto.economico;
                this.UI.addToast("Impacto económico eliminado");
              }
            }
            break;
          case 'ODS':
            // Check repeats - Placed here instead of isValid() so it's easier to port
            let usedOds = this.data.impacto.ods.map(x => x.odsId);
            usedOds.push(ok.auxOds.selected.id);
            let odsRepetidos = usedOds.filter((x, i) => usedOds.indexOf(x) !== i);
            if (odsRepetidos.length > 0) {
              this.UI.addToast("ODS já adicionada");
            } else { // We can add it
              this.data.impacto.ods.push({
                odsId: ok.auxOds.selected.id,
                ods: { id: ok.auxOds.selected.id, designacao: ok.auxOds.selected.designacao }
              });
              this.UI.addToast("ODS adicionado com sucesso");
            }
            break;
          case 'Social':
            if(ok.auxImpactoSocial && ok.auxImpactoSocial.selected.value) { // Has "Yes" selected
              this.data.auxImpactoSocial = angular.copy(ok.auxImpactoSocial);
              this.data.impacto.social = ok.impacto.social;
              this.UI.addToast("Impacto social atualizado");
            } else { // No social data is defined, delete it
              if (this.data.impacto.social) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoSocial.selected = undefined;
                delete this.data.impacto.social;
                this.UI.addToast("Impacto social eliminado");
              }
            }
            break;
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler dados para edição. Verifique a sua ligação");
    });
  };

  // Function called when changing Sim/Não
  // Clear text if it becomes Não
  togglePolicyInfluence = () => {
    if (this.data.auxImpactoPolicyInfluence) {
      if (this.data.auxImpactoPolicyInfluence.selected.value === 0) { // It was disabled, clear text
        this.data.impacto.policyInfluence = null;
      } else { // Do nothing
      }
    }
  };

  // Returns true or false if impactos data is ok to set to database
  verifyImpactos = (impacto) => {
    let defer = this.$q.defer();
    // Ambiental - Nothing to check
    // Social - Nothing to check
    // Económico - Nothing to check

    // ODS - Verifica ODSs individuais
    let deferOds = this.$q.defer();
    if (impacto.ods && impacto.ods.length > 0) {
      let odsTasks = [];
      for (let i = 0; i < impacto.ods.length; i++) {
        let o = this.$q.defer();

        this.ServicoService.fieldValueExists('id', impacto.ods[i].id, this.Ods).then((exists) => {
          o.resolve(exists);
        }).catch(error => {
          o.reject(error);
        });
        odsTasks.push(o.promise);
      }

      this.$q.all(odsTasks).then(x => {
        deferOds.resolve(true);
      }).catch(error => {
        deferOds.reject(error);
      });
    } else {
      deferOds.resolve(true);
    }

    this.$q.all([deferOds.promise]).then(x => {
      defer.resolve();
    }).catch(error => {
      this.UI.addToast("Não foi possível verificar dados de impactos. Verifique a ligação");
      defer.reject(error);
    });

    return defer.promise;
  };

  // Save impacto data to database, update object with impactoId of type Model
  saveImpacto = (imp, object, Model) => {
    let defer = this.$q.defer();
    let newImpacto = {
      id: 0,
      ambiental: imp.ambiental || null,
      economico: imp.economico || null,
      social: imp.social || null,
      observacoes: imp.observacoes || null,
      policyInfluence: imp.policyInfluence || null,
      criadoPorId: this.user.id,
      dataCriacao: moment().format()
    };

    this.Impacto.create(newImpacto).$promise.then((impacto) => {
      // Save impactoId to base object for reference
      object.impactoId = impacto.id;
      Model.upsert(object).$promise.then((res) => {
        defer.resolve();
        // Create all ODS
        this.ServicoService.createMultipleData(this.ImpactoOds, imp.ods, impacto.id, 'impactoId').then(x => {
          defer.resolve();
        }).catch(error => {
          console.log(error);
          defer.reject({ok: false, output: 'Impacto - ODS'});
        });
      }).catch((error) => {
        console.log(error);
        defer.reject({ok: false, output: 'Ligação a Impacto'});
      });
    }).catch((error) => {
      console.log(error);
      defer.reject({ok: false, output: 'Impacto'});
    });

    return defer.promise;
  };

  removeImpacto = (tipo, index) => {
    switch(tipo) {
      case 'Ambiental':
        this.data.auxImpactoAmbiental.selected = undefined;
        delete this.data.impacto.ambiental;
        this.UI.addToast("Impacto ambiental eliminado");
        break;
      case 'Económico':
        this.data.auxImpactoEconomico.selected = undefined;
        delete this.data.impacto.economico;
        this.UI.addToast("Impacto económico eliminado");
        break;
      case 'ODS':
        if (index < this.data.impacto.ods.length) {
          this.data.impacto.ods.splice(index, 1);
          this.UI.addToast("Objetivo eliminado");
        }
        break;
      case 'Social':
        this.data.auxImpactoSocial.selected = undefined;
        delete this.data.impacto.social;
        this.UI.addToast("Impacto social eliminado");
        break;
    }
  };

}

ServicoCreateServicoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'ServicoService', 'Servico', 'ServicoParticipante', 'ServicoInstituicao', 'ServicoAreaInterdisciplinar', 'EntidadeFinanciadora', 'Investigador', 'Instituicao', 'AreaInterdisciplinar', 'Setor', 'Impacto', 'ImpactoOds', 'Ods', 'Pais'];
